import { documentsCollectionSolution, type SystemTaskKey, type Task } from "@recobra/schemas/task";

/**
 * Task types whose execution outcome is derived rather than picked by the
 * executor — the modal locks the solution picker to this value instead of
 * showing choices.
 */
const LOCKED_SOLUTIONS: Partial<Record<SystemTaskKey, (task: Task) => string>> = {
  provide_case_documents: documentsCollectionSolution,
};

export const resolveLockedSolution = (task: Task | null | undefined): string | null =>
  (task?.system ? LOCKED_SOLUTIONS[task.system]?.(task) : null) ?? null;
